const financeActivityTypes = {
  MARKET_ORDER: 'MARKET_ORDER',
  INVOICE: 'INVOICE',
  PAYOUT: 'PAYOUT'
};

export default financeActivityTypes;